import { AppConfig } from '../../../app-config'
import getUserDetails from '../../../utils/actions/getUserDetails'
import { getLeadSource } from '../../../utils/analytics/leadSourceHelper'
import { triggerSimpleAjax } from '../../../utils/http-helper'
const API_URL = AppConfig.api_url

/**
 * This method handles the signup API req and basic success/error responses
 * @param {object} param
 *  -- param structure: {
 *  {string} signupType
 *  {object} reqObj
 *  {string} campaignItineraryId
 *  {function} successSubmitCallback - used to set submitting status in context
 *  {funciton} failureSubmitCallback - used to set errors state of signup context & submit status
 * }
 */
export const triggerLogin = ({
	reqObj = {},
	successSubmitCallback,
	failureSubmitCallback,
	dispatch,
	lastLocation = {},
	router,
}) => {
	console.log({ reqObj })
	let url = `${API_URL}user/login`
	return new Promise((resolve, reject) => {
		triggerSimpleAjax({
			url,
			method: 'POST',
			body: reqObj,
			onSuccess: response => {
				if (response.status === 'SUCCESS') {
					const leadSource = getLeadSource({
						router,
						lastLocation,
					})

					getUserDetails({
						req_data: { prod_type: leadSource.prod_type },
						authType: 'LOGIN',
						dispatch,
					})
						.then(userResponse => {
							resolve(userResponse)

							successSubmitCallback(userResponse)
						})
						.catch(reject)
				} else {
					failureSubmitCallback({
						error: response.message,
					})
					// reject(new Error('Login Failed'))
				}
			},
			onFailure: error => {
				failureSubmitCallback(error)
				reject(error)
			},
		})
	})
}
